const componentStyles = (theme) => ({
  listItem: {
    border: "1px solid #e9ecef",
    borderWidth: "0 0 1px",
    "&:last-child": {
      borderBottomWidth: 0,
    },
  },
  smallAvatar: {
    width: 37,
    height: 37,
    fontSize: "0.85rem",
    border: `2px solid ${theme.palette.background.paper}`,    
  },
  issueTitle: {
    marginBottom:7,
    fontWeight: 'bold',
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column-reverse",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
  },
  issueRedmineName: {
    borderRadius: 16,
    paddingLeft: 7,
    paddingRight: 7,
    paddingTop: 3,
    paddingBottom: 3,
    marginBottom: 4,
    fontSize: "70%",
    backgroundColor: theme.palette.gray[300],
    color: theme.palette.gray[900],
    display: "inline-block",
    [theme.breakpoints.up("md")]: {
      marginLeft: 15,
      fontSize: "75%",
      paddingLeft: 10,
      paddingRight: 10,
      marginBottom: 0,
    }
  },
  issueParams: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      flexDirection: "row",
    },
  },
  issueParam: {
    display: "flex",
    fontSize: "90%",
    [theme.breakpoints.up("md")]: {
      marginRight: 20,
    },
  },
  issueParamValue: {
    fontWeight: "bold",
  }
});

export default componentStyles;